<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Manual Transaction Update</div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text class="pb-2">
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-form ref="form" v-model="valid">
            <v-row class="ms-1 me-1">
              <v-col cols="12" md="2" lg="2" xs="12">
                <v-text-field
                  placeholder="Enter Pin Number"
                  v-model="pin_number"
                  outlined
                  :rules="FieldRequired('Pin Number')"
                  dense
                ></v-text-field>
              </v-col>

              <div class="d-flex mt-1">
                <v-btn
                  depressed
                  small
                  class="text-capitalize"
                  color="primary"
                  :loading="isloadagents"
                  :disabled="isloadagents"
                  @click="getFilterTransaction()"
                  outlined
                  >Get Results</v-btn
                >
              </div>
            </v-row>
          </v-form>
        </v-card>
      </v-card-text>

      <v-row no-gutters v-if="is_visible">
        <v-col cols="12" md="6" class="pe-2">
          <div class="ms-4">
            <v-toolbar color="#ffeee1" flat dense>
              <span
                >Transaction Info :- {{ transactionList.transaction_id }}</span
              ><span v-if="showChip"
                ><v-chip
                  class="ma-2"
                  small
                  :color="returnColor(transactionList.status)"
                  label
                >
                  {{ transactionList.status }}
                </v-chip></span
              >
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-simple-table dense class="ma-3">
              <tbody>
                <tr>
                  <td>Channel Partner</td>
                  <td>
                    <span class="font-weight-bold">{{
                      transactionList.parent_coll_sub_agent_cd
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="">Sender Name</td>
                  <td class="font-weight-bold">
                    {{ transactionList.sender_name }}
                  </td>
                </tr>
                <tr>
                  <td>Beneficiary Name</td>
                  <td class="font-weight-bold">
                    {{ transactionList.beneficiary_name }}
                  </td>
                </tr>
                <tr>
                  <td>Transaction Date</td>
                  <td class="font-weight-bold">
                    {{ transactionList.send_date }}
                  </td>
                </tr>
                <tr>
                  <td>Beneficiary Country</td>
                  <td class="font-weight-bold">
                    {{ transactionList.country }}
                  </td>
                </tr>
                <tr>
                  <td>Payout Amount</td>
                  <td class="font-weight-bold">
                    <span class="font-weight-bold">
                      {{ transactionList.amount_sent }}</span
                    >
                  </td>
                </tr>
                <tr>
                  <td>Collected Amount</td>
                  <td class="font-weight-bold">
                    <span class="font-weight-bold">
                      {{ transactionList.receiving_amount }}</span
                    >
                  </td>
                </tr>

                <tr>
                  <td>Payment Mode</td>
                  <td class="font-weight-bold">
                    <span class="font-weight-bold">
                      {{ transactionList.mode_of_payment }}</span
                    >
                  </td>
                </tr>
                <!-- <tr>
                  <td>Transcation Status</td>
                  <td class="font-weight-bold">
                    <span class="font-weight-bold">
                      {{ transactionList.sender_name }}</span
                    >
                  </td>
                </tr> -->
              </tbody>
            </v-simple-table>
          </div>
        </v-col>

        <v-col cols="12" md="6">
          <div class="me-4">
            <v-toolbar color="#ffeee1" flat dense>
              <span>Update Transaction Status</span>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-form style="width: 95%" class="m-auto mt-5" ref="statusForm">
              <v-row>
                <v-col>
                  <v-autocomplete
                    outlined
                    dense
                    placeholder="Status"
                    :items="parameterstatusList"
                    item-text="text"
                    item-value="value"
                    v-model="status"
                    :loading="isStatusLoading"
                    :rules="FieldRequired('Status')"
                  ></v-autocomplete>
                  <v-alert
                    v-if="statusOptionsLoaded && !parameterstatusList.length"
                    dense
                    text
                    type="info"
                  >
                    No status options are available.
                  </v-alert>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col>
                  <v-autocomplete
                    item-text="text"
                    item-value="value"
                    outlined
                    dense
                    placeholder="Stage"
                    :items="parameterstageList"
                    v-model="stage"
                    :rules="FieldRequired('Stage')"
                  ></v-autocomplete>
                </v-col>
              </v-row> -->
              <v-row>
                <v-col>
                  <v-textarea
                    v-model="remarksdata"
                    placeholder="Remarks"
                    dense
                    outlined
                    height="60px"
                    auto-grow
                    row-height="5"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="mb-4">
                  <v-btn
                    depressed
                    small
                    class="text-capitalize"
                    color="primary"
                    outlined
                    :disabled="isStatusLoading || !parameterstatusList.length"
                    @click="openUpdateStatusDialog()"
                    >Update Status</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <!-- <OverlayPageVue :showOverlay="loader" /> -->
    <v-dialog persistent v-model="updateStatusDialog" width="400">
      <v-card>
        <v-toolbar color="#050048" dark flat dense>
          <span>Approval</span>
          <v-spacer></v-spacer>
          <v-btn depressed icon @click="updateStatusDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text
          ><h5 class="text-center font-weight-bold mt-2">
            Are you sure you want update the status?
          </h5></v-card-text
        >
        <v-divider class="pa-0 ma-0"></v-divider>
        <v-card-actions class="ma-0 pt-0">
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            small
            class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
            color="primary"
            :loading="isUpdating"
            :disabled="isUpdating"
            @click="updateStatusPinnumber()"
            ><v-icon small>mdi-content-save-plus-outline</v-icon>
            Update
          </v-btn>
          <v-btn
            depressed
            small
            class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
            color="primary"
            outlined
            @click="updateStatusDialog = false"
            ><v-icon small>mdi-close-circle-outline</v-icon>cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
// import OverlayPageVue from "@/utils/OverlayPage.vue";
import PaymentService from "@/services/PaymentService/paymentService.js";
import alerts from "@/mixins/alerts";
import { FieldRequired } from "@/utils/validation.js";
import commonService from "@/services/CommonService/commonService.js";
export default {
  mixins: [alerts],
  name: "Manual Transaction Update",
  components: {
    // OverlayPageVue,
  },
  data: () => {
    return {
      FieldRequired,
      valid: false,
      pin_number: "",
      status: "",
      // stage: null,
      remarksdata: "",
      updateStatusDialog: false,
      datapin_number: null,
      transactionList: [],
      // parameterstageList: [],
      parameterstatusList: [],
      isloadagents: false,
      isStatusLoading: false,
      statusOptionsLoaded: false,
      isUpdating: false,
      showChip: false,
      is_visible: false,
    };
  },

  methods: {
    returnColor(status) {
      if (status == "Paid") {
        return "success";
      } else if (status == "Cancel") {
        return "error";
      } else if (status == "Hold") {
        return "orange";
      } else if (status == "Pending") {
        return "yellow";
      } else {
        return "primary";
      }
    },
    async getFilterTransaction() {
      if (this.$refs.form.validate()) {
        this.isloadagents = true;
        this.is_visible = false;
        this.showChip = false;
        this.status = "";
        this.remarksdata = "";
        this.updateStatusDialog = false;
        this.statusOptionsLoaded = false;
        this.parameterstatusList = [];
        const params = {
          beneficiary_name: null,
          partner_id: null,
          pin_number: this.pin_number,
          txn_status: "All",
          from_date: null,
          to_date: null,
          skip: 0,
          limit: 1,
        };
        try {
          const responseData = await PaymentService.getTransitionDetails(
            params,
          );
          const transactions = responseData?.data?.data;
          if (
            responseData?.data?.status_code === 200 &&
            Array.isArray(transactions) &&
            transactions.length
          ) {
            this.transactionList = transactions[0];
            this.datapin_number = transactions[0].transaction_id;
            await this.getparameterstatus("MTU");
            this.is_visible = true;
            this.showChip = true;
          } else {
            this.transactionList = [];
            this.datapin_number = null;
            this.showAlertError(
              `Failed: ${responseData?.data?.message || "Transaction not found"}`,
            );
          }
        } catch (e) {
          console.error(e);
          this.showAlertError("Unable to load the transaction. Please try again.");
        } finally {
          this.isloadagents = false;
        }
      }
    },
    async getparameterstatus(code) {
      this.isStatusLoading = true;
      this.statusOptionsLoaded = false;
      try {
        const response = await commonService.getparameterdropdowns(code);
        if (response.data.status_code === 200) {
          this.parameterstatusList = response.data.data.map((item) => ({
            text: item.value,
            value: item.value_code,
          }));
        } else {
          this.parameterstatusList = [];
          this.showAlertError(
            response.data.message || "Unable to load transaction statuses.",
          );
        }
      } catch (error) {
        this.parameterstatusList = [];
        console.error(error);
        this.showAlertError("Unable to load transaction statuses.");
      } finally {
        this.isStatusLoading = false;
        this.statusOptionsLoaded = true;
      }
    },
    // async getparameterstage(code) {
    //   this.loaderOverlay = true;
    //   try {
    //     const response = await commonService.getparameterdropdowns(code);
    //     if (response.data.status_code === 200) {
    //       this.parameterstageList = response.data.data.map((i) => {
    //         return { text: i.value, value: i.value_code };
    //       });
    //     } else {
    //       this.parameterstageList == [];
    //     }
    //   } catch (error) {
    //     this.parameterstageList = [];

    //     console.error(error);
    //   }
    // },
    openUpdateStatusDialog() {
      if (this.$refs.statusForm.validate()) {
        this.updateStatusDialog = true;
      }
    },
    async updateStatusPinnumber() {
      const validate = this.$refs.statusForm.validate();
      if (validate && !this.isUpdating) {
        this.isUpdating = true;
        try {
          const responseData = await PaymentService.updateStatusPinnumber({
            pin_number: this.datapin_number,
            txn_status: this.status,
            remarks: this.remarksdata,
          });
          if (responseData && responseData.data.status_code == 200) {
            this.updateStatusDialog = false;
            this.showAlertSuccess(
              `Transaction Status Updated : ${responseData.data.message}`,
            );
            await this.getFilterTransaction();
          } else {
            this.showAlertError(`Update Failed : ${responseData.data.message}`);
          }
        } catch (error) {
          console.log(error.response);
          this.showAlertError("Something went wrong please try again later.");
        } finally {
          this.isUpdating = false;
        }
      }
    },
  },
};
</script>
<style>
.required:after {
  content: " *";
  color: red;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
th,
td {
  border-bottom: 1px solid rgb(231, 229, 229);
  border-collapse: collapse;
  padding: 5px;
}
</style>
